import React, { Component } from 'react';
import TableCheckbox from 'Components/TableCheckbox/TableCheckbox.jsx';
export class AgGridCheckbox extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isCheckBoxUpdated: false,
        }
        this.invokeParentMethod = this.invokeParentMethod.bind(this);
    }

    render() {
        return (
            <span>
                <TableCheckbox
                    id={this.props.node.rowIndex}
                    isSvg
                    isChecked={this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props && this.props.context.componentParent.props.selectedRows && this.props.context.componentParent.props.selectedRows.includes(this.props.data.caseStageId)}
                    onChange={this.invokeParentMethod} />
            </span>
        );
    }

    invokeParentMethod() {
        this.setState({
            isCheckBoxUpdated: true,
        });
        this.props && this.props.context && this.props.context.componentParent && this.props.context.componentParent.props && this.props.context.componentParent.props.onCheckboxClick && this.props.context.componentParent.props.onCheckboxClick(this.props.data.caseStageId);
    };
}
export default AgGridCheckbox;